import GeneralModal from "../GeneralModal";
import {appArray} from "../../../App";


function ToSApp() {

    return (
        <GeneralModal id='tos'>
            <div>
                <h1>Terms of Service</h1>
                <p>
                    By using this website, you agree to the following terms of service:
                    {/* Explain that this website is for educational purposes and does not deliver any actual material. Its just for jokes*/}
                    <ul>
                        <li>
                            This website is for educational purposes only. It does not deliver any actual material.
                        </li>
                        <li>
                            This website is not affiliated with any real company.
                        </li>
                    </ul>
                </p>
            </div>

        </GeneralModal>
    )
};

export default ToSApp;
